import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/395W_Hyundai.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Hyundai HiA-S395HI Commercial Panel" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/Hyundai395W.js